interface BuildMetadata {
  versions: { admin: string; booking: string };
  commitHash: string;
  commitDate: string;
  gitDescription: string;
  dirty: boolean;
  sourceHash: string;
  builtAt: string;
}

declare global {
  const __BUTLERAPP_BUILD_INFO__: BuildMetadata;
}

export const buildMetadata = __BUTLERAPP_BUILD_INFO__;

type BuildComponent =
  | "admin-ui"
  | "booking-loader"
  | "booking-form"
  | "booking-form/admin"
  | "campaign-tracker";

const logged = new Set<BuildComponent>();

export function logBuild(
  component: BuildComponent,
  details: { assetUrl?: string; loadsBundleHash?: string; force?: boolean } = {},
) {
  if (logged.has(component) && !details.force) return;
  logged.add(component);

  const { versions, ...metadata } = buildMetadata;
  // One searchable, copyable console message, including all fields even when
  // a console collector cannot expand JavaScript objects.
  console.info(`[Butlerapp build] ${JSON.stringify({
    component,
    version: component === "admin-ui" ? versions.admin : versions.booking,
    ...metadata,
    mode: import.meta.env.MODE,
    assetUrl: details.assetUrl ?? null,
    loadsBundleHash: details.loadsBundleHash || null,
  })}`);
}
